import React from "react";
import { Resizable } from "re-resizable";

interface SnResizableProps {
  width?: string | number;
  minWidth?: number;
  minHeight?: number;
  onResizeStop?: (width: number) => void;
  enable?: { [key: string]: boolean };
  children?: React.ReactNode;
  menuName: string;
  defaultSize: { [key: string]: string | number };
}

export default function SnResizableLNR({
  width,
  minWidth,
  minHeight,
  onResizeStop,
  enable,
  children,
  menuName,
  defaultSize,
}: SnResizableProps) {
  const handleResizeStop = (
    event: MouseEvent | TouchEvent,
    direction: string,
    ref: HTMLElement,
    delta: { width: number; height: number }
  ) => {
    const width = ref.offsetWidth;

    let newMenuSize = {};
    let menuSize = localStorage.getItem("menuSize");
    if (menuSize) {
      const parsedMenuSize = JSON.parse(menuSize);

      // menuName에 해당하는 객체가 없다면 추가
      if (!parsedMenuSize[menuName]) {
        parsedMenuSize[menuName] = {};
      }

      if (defaultSize.grid1Width) {
        parsedMenuSize[menuName].grid1Width = defaultSize.grid1Width;
        parsedMenuSize[menuName].grid2Width = width;
      } else {
        parsedMenuSize[menuName].grid1Width = width;
        parsedMenuSize[menuName].grid2Width = defaultSize.grid2Width;
      }
      newMenuSize = { ...parsedMenuSize };
    } else {
      if (defaultSize.grid1Width) {
        newMenuSize = {
          [menuName]: {
            grid1Width: defaultSize.grid1Width,
            grid2Width: width,
          },
        };
      } else {
        newMenuSize = {
          [menuName]: {
            grid1Width: width,
            grid2Width: defaultSize.grid2Width,
          },
        };
      }
    }
    localStorage.setItem("menuSize", JSON.stringify(newMenuSize));

    onResizeStop && onResizeStop(width);
  };

  return (
    <Resizable
      size={{
        ...(width && { width }),
      }}
      minWidth={minWidth}
      minHeight={minHeight}
      onResizeStop={handleResizeStop}
      enable={enable}
    >
      {children}
    </Resizable>
  );
}
